import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { EMPTY, Observable, catchError } from 'rxjs';
import { MfaClient, MfaResponse } from '..';

@Injectable()
export class MfaResolver implements Resolve<MfaResponse> {
  constructor(private readonly router: Router, private readonly mfaClient: MfaClient) {}

  resolve(): Observable<MfaResponse> {
    return this.mfaClient.getMfa(true).pipe(
      catchError((error) => {
        // TODO: 23844 USS: Fallbackseite für 400 Bad Request https://dev.azure.com/techgroup/Maison%20du%20Software/_workitems/edit/23844
        this.router.navigate(['errors/403']);

        this.mfaClient.notify(error);
        return EMPTY;
      })
    );
  }
}
